import * as Yup from 'yup';
import moment from 'moment';
import createSucursalFormModel from './createSucursalFormModel';
const {
  formField: {
    sucursal_name,
    sucursal_address,
    country,
    departament,
    municipaly,
    workplace,
    family_fund_compensation,
    landline,
    cell_phone,
    arl,
    associated_bank,
    type_account_bank,
    account_number,
    logo_sucursal,
  },
} = createSucursalFormModel;

export default [
  // INFORMACION BASICA
  Yup.object().shape({
    [sucursal_name.name]: Yup.string().required(`${sucursal_name.requiredErrorMsg}`),
    [sucursal_address.name]: Yup.string().required(`${sucursal_address.requiredErrorMsg}`),
    [workplace.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${workplace.requiredErrorMsg}`),

    [family_fund_compensation.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${family_fund_compensation.requiredErrorMsg}`),

    [country.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${country.requiredErrorMsg}`),
    [departament.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${departament.requiredErrorMsg}`),
    [municipaly.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${municipaly.requiredErrorMsg}`),
    [landline.name]: Yup.string().nullable(),
    [cell_phone.name]: Yup.string().required(`${cell_phone.requiredErrorMsg}`),
    [associated_bank.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${associated_bank.requiredErrorMsg}`),
    [type_account_bank.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${type_account_bank.requiredErrorMsg}`),
    [account_number.name]: Yup.string().required(`${account_number.requiredErrorMsg}`),
    [arl.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${arl.requiredErrorMsg}`),
    [logo_sucursal.name]: Yup.string().required(`${logo_sucursal.requiredErrorMsg}`),
    [logo_sucursal.name]: Yup.string().required(`${logo_sucursal.requiredErrorMsg}`),
  }),
];
